import type { HistorySessionListItem } from '../../../services/historyTypes'
import { EmptyState } from '../../patterns/EmptyState'
import { Users, Mic, Video } from 'lucide-react'

function groupByDay(items: HistorySessionListItem[]) {
  const out: { day: string; items: HistorySessionListItem[] }[] = []
  for (const it of items) {
    const day = it.startedAt.slice(0, 10)
    const last = out[out.length - 1]
    if (last && last.day === day) last.items.push(it); else out.push({ day, items: [it] })
  }
  return out
}
const fmtTime = (iso: string) => new Date(iso).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
const fmtDur = (s: number) => `${Math.floor(s / 60)}m`

export default function SessionList({ items, loading, selectedId, onSelect }: {
  items: HistorySessionListItem[]; loading: boolean; selectedId: string | null; onSelect: (id: string) => void
}) {
  if (loading) return <div className="p-4 text-sm text-muted-foreground">Loading...</div>
  if (!items.length) return <EmptyState size="sm" title="No sessions yet" description="Past calls will appear here." />
  return (
    <div className="py-2">
      {groupByDay(items).map((g) => (
        <div key={g.day}>
          <div className="px-4 py-1 text-xs font-medium text-muted-foreground sticky top-0 bg-card">{g.day}</div>
          {g.items.map((s) => (
            <button key={s.id} onClick={() => onSelect(s.id)}
              className={`w-full text-left px-4 py-2 border-l-2 transition ${selectedId === s.id ? 'border-primary bg-primary/10' : 'border-transparent hover:bg-accent'}`}>
              <div className="flex items-center justify-between">
                <span className="text-sm text-foreground">{fmtTime(s.startedAt)} - {fmtDur(s.durationSec)}</span>
                <span className="flex items-center gap-2 text-xs text-muted-foreground">
                  <Users size={12} />{s.participantCount}
                  {s.hasRecording && <Video size={12} className="text-destructive" />}
                  {s.hasTranscript && <Mic size={12} />}
                </span>
              </div>
              <div className="text-xs text-muted-foreground truncate">{s.aiTopic ?? 'Topic pending'}</div>
            </button>
          ))}
        </div>
      ))}
    </div>
  )
}
